import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Lo compré en marzo y desde ahí no improvisé más. Las secuencias del Tomo 4 las apliqué tal cual con mis 3ros y los chicos se re engancharon.',
  name: 'Lucía Martínez',
  role: 'Profe de Artes Visuales',
  city: 'CABA',
  initial: 'LM',
  color: 'bg-rose-500'
}, {
  quote: 'Soy profe hace 14 años y nunca tuve un material tan completo en español y para Argentina. Las planificaciones del Tomo 6 me salvaron el año entero.',
  name: 'Federico Ramos',
  role: 'Profe de Plástica · Secundaria',
  city: 'Córdoba',
  initial: 'FR',
  color: 'bg-brand-500'
}, {
  quote: 'Pensé que era otro PDF más. Me equivoqué. Es un sistema. Tengo todo organizado por tomo y por año. Dejé de armar consignas a las 11 de la noche.',
  name: 'Soledad García',
  role: 'Profe de Educación Artística',
  city: 'Rosario',
  initial: 'SG',
  color: 'bg-emerald-500'
}, {
  quote: 'Los bonos solos valen el precio. El de Rúbricas Express lo uso TODAS las semanas. Encima los Proyectos para Ferias me dieron 3 ideas que ya implementé.',
  name: 'Mariana López',
  role: 'Profe de Arte · 1ro a 5to',
  city: 'La Plata',
  initial: 'ML',
  color: 'bg-indigo-500'
}, {
  quote: 'Me lo recomendó una colega del depto. Lo descargué un viernes a la noche y el lunes ya tenía la primera secuencia armada para mis 5tos. Acceso inmediato real.',
  name: 'Javier Pereyra',
  role: 'Profe de Educación Visual',
  city: 'Mendoza',
  initial: 'JP',
  color: 'bg-amber-500'
}];
export function Testimonials() {
  return <section className="py-20 lg:py-24 bg-white" data-id="element-191">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-193">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 text-brand-700 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-100" data-id="element-194">
            Voces reales
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-195">
            Lo que dicen{' '}
            <span className="text-brand-500" data-id="element-196">+1.800 profes de Arte</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className={`bg-ink-50 rounded-2xl p-6 border border-ink-100 hover:shadow-card transition-all relative ${i === 0 ? 'lg:col-span-1' : ''} ${i === 3 ? 'lg:col-start-1' : ''}`} data-id="element-198">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-brand-100" fill="currentColor" data-id="element-199" />
              <div className="flex text-brand-500 mb-4" data-id="element-200">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-201" />)}
              </div>
              <p className="text-ink-700 leading-relaxed mb-6 text-[15px]" data-id="element-202">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-ink-100" data-id="element-203">
                <div className={`${t.color} w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md`} data-id="element-204">
                  {t.initial}
                </div>
                <div data-id="element-205">
                  <div className="font-bold text-ink-900 text-sm" data-id="element-206">{t.name}</div>
                  <div className="text-ink-500 text-xs" data-id="element-207">
                    {t.role} · 📍 {t.city}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}